import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const AuthModal = ({ isOpen, onClose, onLogin, onRegister, error }) => {
    const [isLoginMode, setIsLoginMode] = useState(true);

    if (!isOpen) return null;

    return (
        <div className={`modal ${isOpen ? 'active' : ''}`} onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '450px' }}>
                <div className="modal-header">
                    <h3>{isLoginMode ? 'Вход' : 'Регистрация'}</h3>
                    <button className="btn-icon" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                
                {isLoginMode ? (
                    <LoginForm 
                        onLogin={onLogin}
                        onSwitchToRegister={() => setIsLoginMode(false)}
                        error={error}
                    />
                ) : (
                    <RegisterForm 
                        onRegister={onRegister}
                        onSwitchToLogin={() => setIsLoginMode(true)}
                        error={error}
                    />
                )}
            </div>
        </div>
    );
};

export default AuthModal;
